// California Market Configuration

export const CALIFORNIA_SHOWROOM = {
  name: "BBQ Island Liquidators - Inland Empire",
  address: {
    street: "14528 Meridian Parkway, Ste B",
    city: "March Air Reserve Base",
    state: "California",
    stateAbbr: "CA",
    zip: "92518",
    full: "14528 Meridian Parkway, Ste B, March Air Reserve Base, CA 92518",
  },
  phone: "(951) 904-2370", // California CallRail tracking number
  email: "hello@bbqislandliquidators.com",
  hours: {
    weekday: "Monday-Friday 10am-5pm",
    weekend: "Saturday 10am-5pm | Sunday 11am-4pm",
  },
  coordinates: {
    lat: 33.8804,
    lng: -117.2626,
  },
  googleMapsQuery: "14528+Meridian+Parkway+March+Air+Reserve+Base+CA+92518",
};

export interface CaliforniaCity {
  slug: string;
  name: string;
  hasShowroom: boolean;
  metro: string;
  metaTitle: string;
  metaDescription: string;
  h1: string;
  tagline: string;
  introContent: string;
  neighborhoods: string[];
  counties: string[];
  nearbyAreas: string[];
  deliveryRadius: string;
  coordinates: { lat: number; lng: number };
  uniqueContent: string;
  localFAQs: { question: string; answer: string }[];
}

export const CALIFORNIA_CITIES: CaliforniaCity[] = [
  {
    slug: "inland-empire",
    name: "Inland Empire",
    hasShowroom: true,
    metro: "Inland Empire",
    metaTitle: "BBQ Islands & Outdoor Kitchens in Inland Empire, CA | Showroom Open",
    metaDescription: "Visit our Inland Empire showroom for factory-direct outdoor kitchens. Serving Riverside, San Bernardino, Corona & all of Southern California.",
    h1: "Outdoor Kitchens in the Inland Empire",
    tagline: "Southern California's Premier Outdoor Kitchen Showroom",
    introContent: "Visit our brand-new California showroom in the Inland Empire to see 50+ outdoor kitchens on display. We're your factory-direct source for premium BBQ islands, built-in grills, and complete outdoor kitchen packages—all at prices 40-60% below retail.",
    neighborhoods: ["Riverside", "Corona", "Moreno Valley", "Fontana", "Ontario", "Rancho Cucamonga", "Temecula", "Murrieta", "Redlands", "San Bernardino", "Upland", "Chino Hills"],
    counties: ["Riverside County", "San Bernardino County"],
    nearbyAreas: ["Los Angeles", "Orange County", "San Diego", "Palm Springs"],
    deliveryRadius: "All of Southern California",
    coordinates: { lat: 33.8804, lng: -117.2626 },
    uniqueContent: `
      <h2>Your California Outdoor Kitchen Headquarters</h2>
      <p>BBQ Island Liquidators is excited to bring factory-direct outdoor kitchens to Southern California. Our new Inland Empire showroom features over 50 fully-built outdoor kitchen displays, making it easy to see, touch, and compare before you buy.</p>
      <p>Located conveniently off the 215 freeway, we're just a short drive from Riverside, Corona, Temecula, Rancho Cucamonga, and the surrounding communities. We also offer delivery and installation throughout Los Angeles, Orange County, and San Diego.</p>
      <h3>Why Buy Factory Direct?</h3>
      <p>Unlike big-box retailers that mark up prices 2-3x, we work directly with manufacturers to bring you the same premium quality at 40-60% less. Our team has over 20 years of experience in outdoor living, and we'll help you design the perfect setup for your California backyard.</p>
    `,
    localFAQs: [
      {
        question: "Where is your California showroom located?",
        answer: "Our showroom is at 14528 Meridian Parkway, Ste B, in March Air Reserve Base, CA 92518. We're conveniently located off the 215 freeway, easily accessible from Riverside, Corona, and throughout the Inland Empire.",
      },
      {
        question: "Do you deliver to Los Angeles?",
        answer: "Yes! We deliver and install outdoor kitchens throughout Los Angeles, Orange County, San Diego, and all of Southern California. Delivery fees vary by distance from our Inland Empire showroom.",
      },
      {
        question: "What brands do you carry?",
        answer: "We carry premium brands including Bull, Lion, Blaze, Delta Heat, Alfresco, and many more. Our showroom displays feature complete kitchens so you can see the quality in person.",
      },
      {
        question: "Do you offer installation in California?",
        answer: "Yes, we offer professional installation throughout Southern California. Our licensed team handles gas connections, electrical hookups, and complete outdoor kitchen assembly.",
      },
    ],
  },
  {
    slug: "los-angeles",
    name: "Los Angeles",
    hasShowroom: false,
    metro: "Los Angeles",
    metaTitle: "BBQ Islands & Outdoor Kitchens in Los Angeles, CA | Factory Direct",
    metaDescription: "Factory-direct outdoor kitchens delivered to Los Angeles. Visit our Inland Empire showroom or schedule a design consultation. Serving LA, Pasadena, Glendale & more.",
    h1: "Outdoor Kitchens for Los Angeles",
    tagline: "Factory-Direct BBQ Islands Delivered to LA",
    introContent: "Upgrade your Los Angeles backyard with a premium outdoor kitchen at factory-direct prices. From Hollywood Hills to the South Bay, we deliver and install custom BBQ islands throughout LA County. Visit our Inland Empire showroom or schedule a design consultation at your home.",
    neighborhoods: ["Downtown LA", "Hollywood", "Beverly Hills", "Pasadena", "Glendale", "Long Beach", "Santa Monica", "Burbank", "Encino", "Sherman Oaks", "Manhattan Beach", "Torrance"],
    counties: ["Los Angeles County"],
    nearbyAreas: ["Orange County", "Inland Empire", "Ventura County"],
    deliveryRadius: "All of Los Angeles County",
    coordinates: { lat: 34.0522, lng: -118.2437 },
    uniqueContent: `
      <h2>Premium Outdoor Kitchens for Los Angeles Homeowners</h2>
      <p>Los Angeles is known for its perfect outdoor living weather—365 days of grilling potential. BBQ Island Liquidators helps LA homeowners take full advantage with factory-direct outdoor kitchens that look like a million bucks without the million-dollar price tag.</p>
      <h3>Serving Los Angeles from Our Inland Empire Showroom</h3>
      <p>Our California showroom in the Inland Empire is just an hour from most LA neighborhoods. Schedule a visit to see 50+ outdoor kitchens on display, or request an in-home design consultation and we'll come to you.</p>
      <h3>Delivery & Installation Throughout LA</h3>
      <p>We deliver and install outdoor kitchens throughout Los Angeles County, from the San Fernando Valley to the South Bay. Our licensed installers handle gas, electrical, and complete assembly—you just fire up the grill.</p>
    `,
    localFAQs: [
      {
        question: "Do you have a showroom in Los Angeles?",
        answer: "Our showroom is located in the Inland Empire (14528 Meridian Parkway, March Air Reserve Base, CA 92518), about an hour from most LA neighborhoods. We also offer in-home design consultations for Los Angeles customers.",
      },
      {
        question: "How much does delivery to Los Angeles cost?",
        answer: "Delivery fees to Los Angeles vary based on your specific location. Contact us for a free quote that includes delivery and installation to your LA address.",
      },
      {
        question: "Do you serve all of Los Angeles County?",
        answer: "Yes! We deliver and install outdoor kitchens throughout LA County, including Downtown LA, Hollywood, Pasadena, Glendale, Long Beach, Santa Monica, the Valley, and all surrounding areas.",
      },
      {
        question: "Can I schedule a design consultation at my home?",
        answer: "Absolutely. We offer free in-home design consultations for Los Angeles customers. Our team will measure your space, discuss your vision, and provide a custom quote—no obligation.",
      },
    ],
  },
];

export const getCaliforniaCityBySlug = (slug: string): CaliforniaCity | undefined => {
  return CALIFORNIA_CITIES.find((city) => city.slug === slug);
};

export const getCaliforniaShowroomCity = (): CaliforniaCity => {
  return CALIFORNIA_CITIES.find((city) => city.hasShowroom) || CALIFORNIA_CITIES[0];
};
